import { Button, getDirection } from '@marriott/mi-ui-library';
import clsx from 'clsx';
import { FC, useEffect, useState } from 'react';
import { DefaultSecondaryNavigationModel } from '../DefaultSecondaryNavigation.types';
import {
  StyledActiveMenuContainer,
  StyledActiveMenuLabel,
  StyledBackCta,
  StyledCloseButton,
  StyledDropdownIcon,
  StyledMainMenu,
  StyledMainMenuItem,
  StyledMainMenuItems,
  StyledNavigationMenu,
  StyledNavigationMenuWrapper,
  StyledSubMenuWithBackCta,
} from './DefaultSecondaryNavigationMobile.styles';
import NavigationDropdownMobile from '../../NavigationDropdown/NavigationDropdownMobile/NavigationDropdownMobile';

const DefaultSecondaryNavigationMobile: FC<DefaultSecondaryNavigationModel> = props => {
  const [selectedMenuIndex, setSelectedMenuIndex] = useState<number | null>(null);
  const [showNavigationMenu, setShowNavigationMenu] = useState(false);
  const [direction, setDirection] = useState(false);
  const selectedMenuLabel =
    selectedMenuIndex !== null ? props?.defaultSectionNavigationItems?.[selectedMenuIndex]?.menuItemLabel : undefined;
  const activeMenuLabel = selectedMenuLabel || props?.activeMenuItem?.menuLabel;

  useEffect(() => {
    setDirection(getDirection());
  }, []);

  const toggleNavigationMenu = () => {
    if (!showNavigationMenu) {
      document.body.classList.add('no-overflow');
    } else {
      document.body.classList.remove('no-overflow');
      setSelectedMenuIndex(null);
    }
    setShowNavigationMenu(!showNavigationMenu);
  };

  return (
    <StyledNavigationMenuWrapper className="m-container-fullbleed" data-testid="navigation-menu-mobile">
      <StyledNavigationMenu>
        <StyledActiveMenuContainer
          selectedMenuIndex={selectedMenuIndex !== null}
          isMenuOpen={showNavigationMenu}
          onClick={!showNavigationMenu ? () => toggleNavigationMenu() : undefined}
          data-testid="active-menu-container"
          role={!showNavigationMenu ? 'button' : undefined}
          tabIndex={!showNavigationMenu ? 0 : undefined}
          aria-expanded={showNavigationMenu}
        >
          {selectedMenuIndex !== null && (
            <StyledBackCta
              onClick={e => {
                e.stopPropagation();
                setSelectedMenuIndex(null);
              }}
              aria-label="Go back"
            >
              <span className={direction ? `icon-forward-arrow-cropped` : `icon-back-arrow-cropped`}></span>
            </StyledBackCta>
          )}
          <StyledActiveMenuLabel>{activeMenuLabel}</StyledActiveMenuLabel>
          {showNavigationMenu ? (
            <StyledCloseButton onClick={() => toggleNavigationMenu()} data-testid="active-menu" aria-label="Close menu">
              <span className="icon-clear"></span>
            </StyledCloseButton>
          ) : (
            <StyledDropdownIcon aria-hidden="true">
              <span className="icon-dropdown-down"></span>
            </StyledDropdownIcon>
          )}
        </StyledActiveMenuContainer>
        <StyledMainMenu
          className={clsx(showNavigationMenu && 'open')}
          aria-label={props?.navigationAriaLabel}
          data-testid="main-menu"
        >
          <StyledMainMenuItems>
            {props?.defaultSectionNavigationItems?.map((mainMenuItem, menuItemIndex: number) => {
              const hasSubMenu = !!mainMenuItem?.sectionNavigationSubItems?.length;
              return (
                <StyledMainMenuItem key={`main-menu-item-${menuItemIndex}`}>
                  <Button
                    isLink={!hasSubMenu}
                    href={hasSubMenu ? undefined : mainMenuItem.menuItemPath}
                    callback={hasSubMenu ? () => setSelectedMenuIndex(menuItemIndex) : undefined}
                    trackingProperties={props?.trackingProperties}
                    target={mainMenuItem?.openInNewTab ? '_blank' : '_self'}
                  >
                    <span>{mainMenuItem.menuItemLabel}</span>
                    {hasSubMenu && (
                      <span
                        className={`${direction ? `icon-arrow-left` : `icon-arrow-right`} sub-menu-toggler`}
                        data-testid={`sub-menu-toggler-${menuItemIndex}`}
                      ></span>
                    )}
                  </Button>

                  {mainMenuItem?.enableDropdown && hasSubMenu && (
                    <StyledSubMenuWithBackCta
                      className={clsx(selectedMenuIndex === menuItemIndex && 'open')}
                      data-testid={`sub-menu-${menuItemIndex}`}
                    >
                      <NavigationDropdownMobile
                        menuItemLabel={mainMenuItem.menuItemLabel}
                        ariaLabel={mainMenuItem.menuItemLabel}
                        sectionNavigationSubItems={mainMenuItem?.sectionNavigationSubItems || []}
                        activeMenuItem={props?.activeMenuItem}
                        trackingProperties={props?.trackingProperties}
                        menuItemIndex={menuItemIndex}
                      />
                    </StyledSubMenuWithBackCta>
                  )}
                </StyledMainMenuItem>
              );
            })}
          </StyledMainMenuItems>
        </StyledMainMenu>
      </StyledNavigationMenu>
    </StyledNavigationMenuWrapper>
  );
};

export default DefaultSecondaryNavigationMobile;
